import { rankOf, suitOf } from "./cards";

const BASE = 15 ** 5;
export const HAND_NAMES = [
  "High Card", "Pair", "Two Pair", "Three of a Kind", "Straight",
  "Flush", "Full House", "Four of a Kind", "Straight Flush",
];

function straightHigh(mask) {
  if (mask & (1 << 14)) mask |= 1 << 1;
  for (let r = 14; r >= 5; r--) {
    const need = 0b11111 << (r - 4);
    if ((mask & need) === need) return r;
  }
  return 0;
}

const enc = (cat, ks) => {
  let v = cat;
  for (let i = 0; i < 5; i++) v = v * 15 + (ks[i] || 0);
  return v;
};

// Returns comparable score for best 5-card hand from 5-7 cards
export function evaluate7(cards) {
  const counts = new Array(15).fill(0);
  const suitCnt = [0, 0, 0, 0];
  const suitMask = [0, 0, 0, 0];
  let mask = 0;
  for (const c of cards) {
    const r = rankOf(c), s = suitOf(c);
    counts[r]++; suitCnt[s]++; suitMask[s] |= 1 << r; mask |= 1 << r;
  }
  let fs = -1;
  for (let s = 0; s < 4; s++) if (suitCnt[s] >= 5) fs = s;
  if (fs >= 0) {
    const sh = straightHigh(suitMask[fs]);
    if (sh) return enc(8, [sh]);
  }
  const quads = [], trips = [], pairs = [], singles = [];
  for (let r = 14; r >= 2; r--) {
    const n = counts[r];
    if (n === 4) quads.push(r);
    else if (n === 3) trips.push(r);
    else if (n === 2) pairs.push(r);
    else if (n === 1) singles.push(r);
  }
  if (quads.length) {
    const q = quads[0];
    let k = 0;
    for (let r = 14; r >= 2; r--) if (r !== q && counts[r]) { k = r; break; }
    return enc(7, [q, k]);
  }
  if (trips.length && (trips.length > 1 || pairs.length)) {
    return enc(6, [trips[0], Math.max(trips[1] || 0, pairs[0] || 0)]);
  }
  if (fs >= 0) {
    const ks = [];
    for (let r = 14; r >= 2 && ks.length < 5; r--) if (suitMask[fs] & (1 << r)) ks.push(r);
    return enc(5, ks);
  }
  const sh = straightHigh(mask);
  if (sh) return enc(4, [sh]);
  if (trips.length) return enc(3, [trips[0], ...singles.slice(0, 2)]);
  if (pairs.length >= 2) {
    return enc(2, [pairs[0], pairs[1], Math.max(pairs[2] || 0, singles[0] || 0)]);
  }
  if (pairs.length === 1) return enc(1, [pairs[0], ...singles.slice(0, 3)]);
  return enc(0, singles.slice(0, 5));
}

export const handCategory = (score) => Math.floor(score / BASE);
export const handName = (score) => HAND_NAMES[handCategory(score)];
